module.exports = __webpack_public_path__ + "img/1494638007.9afa0d93.jpg";